// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-request-list-container {
  padding: 10px;
  border-bottom: 1px solid #c1c1c1;
}

.message-container {
  padding: 10px;
}
.message-container p {
  color: grey;
  text-align: center;
  font-weight: bold;
  font-size: 0.9em;
  margin: 5px;
}

.request-item-wrapper {
  display: inherit;
}

.request-item-wrapper.selected {
  background-color: #e7e7e7;
}

.bottom-toolbar {
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bottom-button-container {
  max-width: 100px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom-button-container p {
  font-size: 0.7em;
  margin: 5px;
  text-align: center;
}

p.message {
  font-size: 0.9em;
  font-weight: bold;
  margin: 5px 0;
}

p.action {
  color: grey;
  text-align: center;
  font-size: 0.85em;
  margin: 5px;
}

.navigation-button {
  box-shadow: none;
}

@media only screen and (max-device-width: 640px) {
  .message-container p {
    font-size: 0.8em;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/requests/requests.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gCAAA;AACJ;;AACA;EACI,aAAA;AAEJ;AADI;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAGR;;AAAA;EACI,gBAAA;AAGJ;;AADA;EACI,yBAAA;AAIJ;;AAFA;EACI,WAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAKJ;;AAHA;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAMJ;AALI;EAAI,gBAAA;EAAkB,WAAA;EAAa,kBAAA;AAUvC;;AARA;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;AAWJ;;AATA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAYJ;;AATA;EACI,gBAAA;AAYJ;;AATA;EACI;IACI,gBAAA;EAYN;AACF","sourcesContent":[".empty-request-list-container {\n    padding: 10px;\n    border-bottom: 1px solid #c1c1c1;\n}\n.message-container {\n    padding: 10px;\n    p {\n        color: grey;\n        text-align: center;\n        font-weight: bold;\n        font-size: 0.9em;\n        margin: 5px;\n    }\n}\n.request-item-wrapper {\n    display: inherit;\n}\n.request-item-wrapper.selected {\n    background-color: #e7e7e7;\n}\n.bottom-toolbar {\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.bottom-button-container {\n    max-width: 100px;\n    margin: 10px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    p { font-size: 0.7em; margin: 5px; text-align: center; }\n}\np.message {\n    font-size: 0.9em;\n    font-weight: bold;\n    margin: 5px 0;\n}\np.action {\n    color: grey;\n    text-align: center;\n    font-size: 0.85em;\n    margin: 5px;\n}\n\n.navigation-button {\n    box-shadow: none;\n}\n\n@media only screen and (max-device-width : 640px) {\n    .message-container p {\n        font-size: 0.8em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
